import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReactElement } from "react";

export type PopupT = {
    id: string;
    header?: ReactElement,
    body: ReactElement,
    footer?: ReactElement,
    className?: string;
    // Optional stable identity. When set, openPopup ignores a second popup with the same key,
    // preventing duplicate stacked popups (e.g. a trigger firing from more than one mount).
    key?: string;
};

export interface AppStateI {
    items: PopupT[];
    wizardStep: number;
    isQuickSave: boolean;
}

const initialState: AppStateI = {
    items: [],
    wizardStep: 0,
    isQuickSave: false,
};

export const popupSlice = createSlice({
    name: 'popup',
    initialState,
    reducers: {
        openPopup: (state, action: PayloadAction<PopupT>) => {
            const { key } = action.payload;
            if (key && state.items.some((p) => p.key === key)) {
                return; // de-dup: a popup with this key is already open
            }
            state.items.push(action.payload);
        },
        closePopup: (state) => {
            state.items.pop();
        },
        closeAllPopups: (state) => {
            state.items = [];
        },
        setWizardStep: (state, action: PayloadAction<number>) => {
            state.wizardStep = action.payload < 0 ? 0 : action.payload;
        },
        setQuickSave: (state, action: PayloadAction<boolean>) => {
            state.isQuickSave = action.payload;
        }
    },
});



export const {
    openPopup,
    closePopup,
    closeAllPopups,
    setWizardStep,
    setQuickSave,
} = popupSlice.actions;

export default popupSlice.reducer;
